// ======================================================================
// FILE:
// src/modules/service_crm/visits/pages/ServiceVisitListPage.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Service Visit Queue
// ======================================================================

import React, {
  useEffect,
  useState,
} from "react";

import serviceVisitService
from "../services/serviceVisitService";

import VisitKpiBar
from "../components/VisitKpiBar";

import VisitFilterBar
from "../components/VisitFilterBar";

import VisitTable
from "../components/VisitTable";

import VisitDrawer
from "../components/VisitDrawer";

import { useNavigate } from "react-router-dom";

export default function ServiceVisitListPage() {


  const navigate = useNavigate();

  const [loading, setLoading] =
    useState(false);

  const [rows, setRows] =
    useState([]);

  const [kpis, setKpis] =
    useState({});

  const [filters, setFilters] =
    useState({});

  const [drawerOpen,
    setDrawerOpen] =
    useState(false);

  const [drawerMode,
    setDrawerMode] =
    useState("view");

  const [selectedTicket,
    setSelectedTicket] =
    useState(null);

  // ==========================================================
  // LOAD DATA
  // ==========================================================

  useEffect(() => {

    loadData();

  }, [filters]);

  async function loadData() {

    try {

      setLoading(true);

      const response =
        await serviceVisitService
          .getVisitQueue(
            filters
          );

      setRows(

        response?.rows || []

      );

      setKpis(

        response?.kpis || {}

      );

    } catch (err) {

      console.error(err);

      alert(
        "Failed to load visits"
      );

    } finally {

      setLoading(false);

    }

  }

  // ==========================================================
  // FILTERS
  // ==========================================================

  function handleApplyFilters(
    values
  ) {

    setFilters(
      values
    );

  }

  // ==========================================================
  // DRAWER
  // ==========================================================

  function handleView(
    row
  ) {

    setSelectedTicket(
      row
    );

    setDrawerMode(
      "view"
    );

    setDrawerOpen(
      true
    );

  }

  function handleAdd(
    row
  ) {

    setSelectedTicket(
      row
    );

    setDrawerMode(
      "add"
    );

    setDrawerOpen(
      true
    );

  }
  function handleTicketDetails(row) {

    navigate(
        `/service-crm/tickets/${row.ticket_id}?readonly=1&source=visits`
    );

}

  function closeDrawer() {

    setDrawerOpen(
      false
    );

    setSelectedTicket(
      null
    );

  }

  // ==========================================================
  // RENDER
  // ==========================================================

  return (

    <div
      className="container-fluid"
    >

      {/* HEADER */}

      <div
        style={{
          marginBottom: 20,
        }}
      >

        <h2
          style={{
            marginBottom: 4,
          }}
        >

          Service Visits

        </h2>

        <div
          style={{
            color: "#6c757d",
          }}
        >

          Track visit history and
          service activities

        </div>

      </div>

      {/* KPI */}

      <VisitKpiBar
        kpis={kpis}
      />

      {/* FILTERS */}

      <VisitFilterBar

        filters={
          filters
        }

        onApply={
          handleApplyFilters
        }

      />

      {/* TABLE */}

      <VisitTable

        rows={
          rows
        }

        loading={
          loading
        }

        onView={
          handleView
        }

        onAdd={
          handleAdd
        }
        onTicketDetails={handleTicketDetails}

      />

      {/* DRAWER */}

      <VisitDrawer

        open={
          drawerOpen
        }

        mode={
          drawerMode
        }

        ticket={
          selectedTicket
        }

        onClose={
          closeDrawer
        }

        onSaved={() => {

          loadData();

        }}

      />

    </div>

  );

}